<template>
  <div>
    <section id="artist-projects-grid" class="artist-projects-grid">
      <CoverPhoto
        v-for="(obj, index) in visibleProjects"
        :key="index"
        :project="obj.project"
        :cover="obj.cover"
        :filteredArtist="filteredArtist"
        />
    </section>

    <div class="artist-projects-load" :class="{'is-loading': isLoading}" v-if="!filteredArtist"></div>
  </div>
</template>

<script>
import CoverPhoto from './components/CoverPhoto'
import lozad from 'lozad'
import { fire } from 'delegated-events'

export default {
  name: 'ArtistProjects',

  components: {
    CoverPhoto
  },

  data() {
    return {
      isLoading: false,
      filteredArtist: null,
      page: -1,
      projects: [],
      visibleProjects: []
    }
  },

  methods: {
    loadPage: function() {
      this.page += 1

      let projects = [...this.projects]

      if (this.filteredArtist) {
        projects = projects.filter(p => p.artistIds.includes(this.filteredArtist))
      }

      const visibleProjects = projects.map(project => {
        const index = this.page % project.covers.length
        const cover = project.covers[index]

        return {
          project,
          cover
        }
      })

      this.visibleProjects = [...this.visibleProjects, ...visibleProjects]

      this.isLoading = false
    }
  },

  mounted() {
    const lazyLoader = lozad('.artist-project-item [data-lazy]:not([data-loaded])')
    lazyLoader.observe()

    const loadObserver = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting && !this.isLoading) {
        this.isLoading = true
        this.loadPage()

        setTimeout(lazyLoader.observe, 250)
      }
    })

    if (!this.filteredArtist) {
      loadObserver.observe(document.querySelector('.artist-projects-load'))
    }

    const url = new URL(window.location)

    if (url.searchParams.has('tag')) {
      const tagList = document.querySelector('[data-tag-list]')

      if (tagList) {
        const tagArea = document.getElementById(tagList.dataset.tagList)

        if (tagArea) {
          const tag = url.searchParams.get('tag')

          let found = false

          tagArea.querySelectorAll('[data-tags]').forEach((x) => {
            const tags = JSON.parse(x.dataset.tags)

            if (tags.includes(tag)) {
              found = true
            }
          })

          if (found) {
            fire(document.documentElement, 'handletag', { tagList, tag })
          }
        }
      }
    }
  },

  created() {
    const initialData = JSON.parse(document.getElementById('artist-projects-data').textContent)

    this.projects = initialData.projects
    this.filteredArtist = initialData.filteredArtist

    window.scrollTo(0, 0)
    this.loadPage()
  }
}
</script>
